import { isTradingDayDate } from './exchange-time'
import {
  getEffectiveTradingDay as getEffectiveTradingDayET,
  getExchangeToday,
  isTradingDay,
} from './exchange-time'

// Re-export exchange-time utilities
export { getExchangeToday, isTradingDay, getEffectiveTradingDayET }

/**
 * Returns the last trading day (Mon-Fri, non-holiday) on or before the given date.
 * Walks backwards from the given date, skipping weekends and holidays.
 */
export function getLastTradingDay(date: Date): Date {
  const d = new Date(date)
  while (!isTradingDayDate(d)) {
    d.setDate(d.getDate() - 1)
  }
  return d
}

/**
 * Returns the effective trading day accounting for the 4 AM ET market open.
 * Before 4 AM ET on weekdays, data is still from the prior session,
 * so this returns the previous trading day. On weekends/holidays, returns the
 * last trading day.
 *
 * When called with a Date, returns a Date (backward compat).
 * When called without arguments, returns a Date using exchange-time-correct logic.
 */
export function getEffectiveTradingDay(now: Date = new Date()): Date {
  const dayOfWeek = now.getDay()
  if (dayOfWeek === 0 || dayOfWeek === 6) return getLastTradingDay(now)

  // Check holidays
  if (!isTradingDayDate(now)) return getLastTradingDay(now)

  // Before 4 AM ET the market hasn't opened — data is still from the prior session
  const ny = now.toLocaleString('en-US', { timeZone: 'America/New_York' })
  const nyMin = new Date(ny).getHours() * 60 + new Date(ny).getMinutes()
  if (nyMin < 240) {
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)
    return getLastTradingDay(yesterday)
  }
  return now
}
